module.exports = __webpack_public_path__ + "static/media/moreHorizontal.14e9b122.svg";